<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch20"></a><a id="page_21"></a><a href="#/contents#ch20"><b>Bathroom Break</b></a></h2>
<p class="noindent"><span>According to one study, a toilet has 49 germs per square inch. A desktop has 20,961.</span></p>
<p class="noindent"><span>Toilet paper was first produced on rolls in the 1870s, but they didn’t become popular until the 1900s.</span></p>
<p class="noindent"><span>King Louis XIV had more than 250 personal chamber pots in and around the Palace of Versailles.</span></p>
<p class="noindent"><span>Britain’s Prince Charles owns a collection of toilet seats.</span></p>
<p class="noindent"><span>Emperor Vespasian introduced pay toilets to Rome in the first century AD.</span></p>
<p class="noindent"><span>Golfers Walter Hagen and Joe Kirkwood once played a round in downtown Tijuana, Mexico, using the toilet in their hotel room as the 18th hole.</span></p>
<p class="noindent"><span>British government toilet paper used to be stamped with “Govt. Property, Now Wash Your Hands.”</span></p>
<p class="noindent"><span>In Australia, outhouses are called “dunnies.”</span></p>
<p class="noindent"><span>The Spike Jones Orchestra used an instrument called the latrinophone—a toilet seat with strings.</span></p>
<p class="noindent"><span>Montana’s Cow Pasture Open golf tournament includes a toilet-seat hole.</span></p>
<p class="noindent"><span>Liberace owned a retracting toilet that sank into the bathroom floor.</span></p>
<p class="noindent"><span>Jack Nicholson has a rattlesnake embedded in his toilet seat.</span></p>
<p class="noindent"><span>During the 1790s, the White House lavatory consisted of an outdoor wooden privy. In 1801, Thomas Jefferson had two outhouses installed, one at each end of the house.</span></p>
<p class="noindent"><span>Thirty-three percent of Americans flush the toilet while still sitting on it.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter20.vue?279afbff